import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Text } from '@solvhealth/jigsaw-v1';
import React, { PureComponent } from 'react';
import { analyticsTrackEvent } from '../../../../core/analytics';
import {
  PROFILE_CARD_ADDRESS_CANCEL,
  PROFILE_CARD_ADDRESS_SAVE,
  PROFILE_CARD_BASIC_CANCEL,
  PROFILE_CARD_BASIC_SAVE,
  PROFILE_CARD_PHARMACY_CANCEL,
  PROFILE_CARD_PHARMACY_SAVE,
  PROFILE_CARD_PHOTO_CANCEL,
  PROFILE_CARD_PHOTO_SAVE,
} from '../../../../core/analytics/events';
import { buildDapiUserProfileObject } from '../../../../core/dapi/userProfile';
import EditBasicsForm from '../EditProfileForm';

import ResponsiveSlideInDialog from '~/components/SolvDesignSystem/Dialog/ResponsiveSlideInDialog';
import EditHomeAddressForm from '../EditHomeAddressForm';
import EditPharmacyForm from '../EditPharmacyForm';
import EditPhotoForm from '../EditPhotoForm';
import { ProfileModalTypes } from './constants';

type Props = {
  fullScreen?: boolean;
  open: boolean;
  modalType?: string;
  closeModal: () => any;
  userProfile?: any;
  updateUserProfileProcessing: (...args: any[]) => any;
  updateUserProfile: (...args: any[]) => any;
  pharmacies?: any[];
  pharmacy?: any;
  searchPharmacies?: (...args: any[]) => any;
  handleCropSave: (...args: any[]) => any;
  userProfilePhoto?: any;
  profileColor?: string;
  position?: any;
  src?: string;
};

class EditProfileModal extends PureComponent<Props> {
  onFormSubmit = (form: any) => {
    const modalInfo = this.getModalInfo();

    analyticsTrackEvent(modalInfo.submitEvent);

    this.props.closeModal();

    const userProfileData = buildDapiUserProfileObject(form);

    this.props.updateUserProfileProcessing();

    this.props.updateUserProfile(this.props.userProfile.user_profile_id, userProfileData);
  };

  onPhotoSubmit = (cropFile: any) => {
    const modalInfo = this.getModalInfo();

    analyticsTrackEvent(modalInfo.submitEvent);

    this.props.handleCropSave(cropFile, this.props.closeModal);
  };

  getModalInfo = () => {
    const {
      modalType,
      userProfile,
      pharmacies,
      searchPharmacies,
      pharmacy,
      userProfilePhoto,
      profileColor,
      position,
      src,
    } = this.props;

    switch (modalType) {
      case ProfileModalTypes.BASICS:
        return {
          title: 'Profile basics',
          submitEvent: PROFILE_CARD_BASIC_SAVE,
          cancelEvent: PROFILE_CARD_BASIC_CANCEL,
          content: (
            <EditBasicsForm
              handleCancel={this.handleCancel}
              handleFormSubmit={this.onFormSubmit}
              userProfile={userProfile}
            />
          ),
        };
      case ProfileModalTypes.ADDRESS:
        return {
          title: 'Home address',
          submitEvent: PROFILE_CARD_ADDRESS_SAVE,
          cancelEvent: PROFILE_CARD_ADDRESS_CANCEL,
          content: (
            <EditHomeAddressForm
              handleCancel={this.handleCancel}
              handleFormSubmit={this.onFormSubmit}
              userProfile={userProfile}
            />
          ),
        };
      case ProfileModalTypes.PHARMACY:
        return {
          title: 'Preferred Pharmacy',
          submitEvent: PROFILE_CARD_PHARMACY_SAVE,
          cancelEvent: PROFILE_CARD_PHARMACY_CANCEL,
          content: (
            <EditPharmacyForm
              handleCancel={this.handleCancel}
              handleFormSubmit={this.onFormSubmit}
              pharmacies={pharmacies}
              pharmacy={pharmacy}
              position={position}
              searchPharmacies={searchPharmacies}
              userProfile={userProfile}
            />
          ),
        };
      case ProfileModalTypes.PHOTO:
        return {
          title: 'Photo',
          submitEvent: PROFILE_CARD_PHOTO_SAVE,
          cancelEvent: PROFILE_CARD_PHOTO_CANCEL,
          content: (
            <EditPhotoForm
              handleCancel={this.handleCancel}
              handlePhotoSubmit={this.onPhotoSubmit}
              profileColor={profileColor}
              src={src ?? ''}
              userProfile={userProfile}
              userProfilePhoto={userProfilePhoto}
            />
          ),
        };
      default:
        return {};
    }
  };

  handleCancel = () => {
    const modalInfo = this.getModalInfo();

    analyticsTrackEvent(modalInfo.cancelEvent);

    this.props.closeModal();
  };

  render() {
    const { fullScreen, closeModal, open } = this.props;
    const modalInfo = this.getModalInfo();

    return (
      <ResponsiveSlideInDialog onClose={closeModal} open={open}>
        <Text variant="h3">{modalInfo.title}</Text>
        {modalInfo.content}
      </ResponsiveSlideInDialog>
    );
  }
}

export default withMobileDialog<Props>({ breakpoint: 'xs' })(EditProfileModal);
